import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import usePolicyTemplates from 'components/Common/PolicyTemplates/Hooks/usePolicyTemplates';
import Templates from './Templates';
import Currency from './Currency';

export default function Index({ policyEnabled, showCurrency }) {
  const { loading, templates } = usePolicyTemplates();

  return (
    <div className="content">

      {!policyEnabled && (
      <section>
        <p className="mt-3 p-3 bg-gray-100 rounded">
          Would you like to get the ball rolling on your Talent
          Insurance Program? Well, it all begins with creating a policy
          for your company. The LeggUP Team would be happy to help setup your policy.
          Click the button to contact us to get started!
        </p>
      </section>
      )}

      <section>
        {loading
          ? <LoadingPlaceholder text="Loading..." />
          : <Templates templates={templates} policyEnabled={policyEnabled} />}

        <div className={`d-flex justify-content-between ${showCurrency ? 'mt-3' : ''}`}>
          <ExternalLink
            href="https://www.leggup.com/about-us/our-pricing"
            variant="link"
            className="mt-lg-4"
          >
            Learn more
          </ExternalLink>

          {showCurrency && (
          <div><Currency /></div>
          )}
        </div>

      </section>
    </div>
  );
}

Index.propTypes = {
  policyEnabled: PropTypes.bool,
  showCurrency: PropTypes.bool,
};

Index.defaultProps = {
  policyEnabled: true,
  showCurrency: false,
};
